import styled from 'styled-components';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { Link } from '@dreryk/react-components';

import { patientTranslationKeys } from '../translations';

import { PatientAssociateModalOpener } from './patientAssociate/PatientAssociateModalOpener';

const PatientAssociateLink = styled(Link)`
   display: inline;
`;

type PatientUnconfirmedAssociateLinkProps = {
   readonly unconfirmedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>;
};

export const PatientUnconfirmedAssociateLink = (props: PatientUnconfirmedAssociateLinkProps): JSX.Element => {
   return (
      <PatientAssociateModalOpener unconfirmedPatient={props.unconfirmedPatient}>
         {({ openModal }) => (
            <PatientAssociateLink
               testId={'patientAssociate'}
               label={patientTranslationKeys.unconfirmed.associateWithExistingPatient}
               onClick={openModal}
            />
         )}
      </PatientAssociateModalOpener>
   );
};
